import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="relative bg-[#0d2818] overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0">
        <div className="absolute top-10 right-10 w-96 h-96 rounded-full bg-primary-500/3 blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-80 h-80 rounded-full bg-accent-500/3 blur-3xl"></div>
      </div>

      <div className="relative z-10 pt-16 md:pt-20 pb-8 px-6 md:px-10 lg:px-16">
        {/* Top: 4 columns */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-14 border-b border-white/10">
          {/* Column 1: Logo */}
          <div className="flex flex-col gap-3">
            <Link to="/" className="text-xl font-heading font-bold text-white tracking-tight cursor-pointer">
              YOYBUY <span className="text-primary-400">SPREADSHEET</span>
            </Link>
            <p className="text-xs text-white/40 leading-relaxed max-w-[200px]">
              Самая полная таблица для закупок из Китая. YOYBUY, Kakobuy и Superbuy в одной системе.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs font-semibold text-white/30 uppercase tracking-[0.15em]">Навигация</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Главная</Link>
              <Link to="/article/yoybuy-spreadsheet-polnoe-rukovodstvo" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Руководство по покупкам</Link>
              <a href="#categories" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap">Категории</a>
              <a href="#comparison" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap">Сравнение</a>
              <a href="#faq" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap">FAQ</a>
              <a href="#blog" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap">Блог</a>
            </div>
          </div>

          {/* Column 3: Categories */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs font-semibold text-white/30 uppercase tracking-[0.15em]">Категории</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/50 hover:text-white transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* Column 4: More Categories + Articles */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs font-semibold text-white/30 uppercase tracking-[0.15em]">Ещё</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/50 hover:text-white transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
              <div className="mt-2 pt-2 border-t border-white/5 flex flex-col gap-2">
                {articles.slice(0, 3).map((article) => (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="text-sm text-white/40 hover:text-white/70 transition-colors whitespace-nowrap truncate cursor-pointer"
                  >
                    {article.title}
                  </Link>
                ))}
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-primary-400 hover:text-primary-300 transition-colors font-medium mt-2 whitespace-nowrap"
              >
                YOYBUY Sheet →
              </a>
            </div>
          </div>
        </div>

        {/* Bottom: Large brand text */}
        <div className="max-w-6xl mx-auto mt-8 md:mt-12">
          <div className="text-[clamp(3rem,8vw,10rem)] font-heading font-extrabold text-white/5 leading-none tracking-tighter select-none">
            YOYBUY
          </div>

          {/* Copyright */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-4">
            <p className="text-xs text-white/25">
              &copy; 2026 yoybuyspreadsheet.top. Все права защищены.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-white/25 hover:text-white/50 transition-colors whitespace-nowrap"
              >
                Основной сайт
              </a>
              <Link
                to="/article/yoybuy-spreadsheet-polnoe-rukovodstvo"
                className="text-xs text-white/25 hover:text-white/50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Руководство
              </Link>
              <a
                href="#blog"
                className="text-xs text-white/25 hover:text-white/50 transition-colors whitespace-nowrap"
              >
                Блог
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}